import { useEffect, useState } from "react";
import Button from "../../components/shared/buttons/button";
import PatternImage from "../../images/Pattern.svg";
import Logo from "../../images/header-logo-captify.svg";
import "../auth/login/login.css";
import { getLoginUrl } from "../../helpers/authSession";
import { ensureDevAuthToken, isDevAuthSkipEnabled } from "../../helpers/devAuth";
import Loader from "../../components/shared/loader/Loader";
import { Routes as AppRoutes } from "../../routes";

export default function AudiologistLogin() {
  const [devAuthLoading, setDevAuthLoading] = useState(isDevAuthSkipEnabled());

  useEffect(() => {
    if (!isDevAuthSkipEnabled()) return;
    ensureDevAuthToken("audiologist").then((ok) => {
      if (ok) {
        window.location.replace(AppRoutes.AudiologistHome.path);
        return;
      }
      setDevAuthLoading(false);
    });
  }, []);

  if (devAuthLoading) {
    return <Loader />;
  }

  return (
    <div className="login_wrapper d-flex justify-content-center align-items-center min-vh-100">
      <div className="login_form text-center position-relative">
        <img src={PatternImage} alt="pattern" />
        <div className="login-outer">
          <div className="text-center mb-4">
            <img src={Logo} alt="logo" />
          </div>
          <div className="login-card">
            <h1>Welcome to Captify Audiologist Dashboard</h1>
            <p className="pt-1 mb-3">
              Sign in with your audiologist account to view and create orders.
            </p>
            <Button
              label="Login"
              className="w-100"
              onClick={() => {
                window.location.href = getLoginUrl();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
